import {VehicleWindshieldAdvertisingAttributeRequestBody} from '../utils/VehicleWindshieldAdvertisingAttributeRequestBody';
import {VehicleGeneralAdvertisingAttributeRequestBody} from './VehicleGeneralAdvertisingAttributeRequestBody';
import {VehiclePlatformAdvertisingAttributeRequestBody} from './VehiclePlatformAdvertisingAttributeRequestBody';

export type AdvertisingAttributeRequestBody = (
  | Omit<VehicleGeneralAdvertisingAttributeRequestBody, 'code' | 'type'>
  | Omit<VehicleWindshieldAdvertisingAttributeRequestBody, 'code' | 'type'>
  | Omit<VehiclePlatformAdvertisingAttributeRequestBody, 'code' | 'type'>
) & {
  code:
    | 'title_extension'
    | 'vin'
    | 'mileage'
    | 'price'
    | 'description'
    | 'price_note'
    | 'model_info'
    | 'contact_email'
    | 'contact_phone'
    | 'url'
    | 'condition'
    | 'financing_price'
    | 'version'
    | 'generation'
    | 'digital_certificate'
    | 'digital_certificate_theme'
    | 'video_url';
  type?:
    | 'string'
    | 'mileage'
    | 'text'
    | 'price'
    | 'email'
    | 'phone'
    | 'financing_price'
    | 'price_note'
    | 'condition'
    | 'digital_certificate'
    | 'digital_certificate_theme';
};
